import { ProductControls } from "@components/product-input/product-controls.enum";

const commonControls: ProductControls[] = [
  ProductControls.ProductName,
  ProductControls.CommonName,
  ProductControls.Qty,
  ProductControls.IsPromoted,
  ProductControls.VendorId,
  ProductControls.Status,
  ProductControls.MoreDescription,
  ProductControls.CategoryId,
  ProductControls.SubcategoryId,
  ProductControls.ProductMedia,
  ProductControls.ProductOptions,
];
export const livestockInputControls: ProductControls[] = [
  ...commonControls,
  ProductControls.MinSize,
  ProductControls.MaxSize,
  ProductControls.SubsubcategoryId,
  ProductControls.IsPreOrder,
  ProductControls.IsRequestQuote,
  ProductControls.IsRareFish,
  ProductControls.ProductExpiry,
  ProductControls.Temperament,
  ProductControls.WaterCondition,
  ProductControls.Wysiwyg,
];

export const tankInputControls: ProductControls[] = [
  ...commonControls,
  ProductControls.CapacityInGallons,
  ProductControls.TankLength,
  ProductControls.TankBreadth,
  ProductControls.TankHeight,
];

export const otherProductInputControls: ProductControls[] = [...commonControls];

export {
  getSegmentForCategory,
  isLivestockCategoryName,
  LIVESTOCK_SEGMENT,
  OTHER_SEGMENT,
  TANK_SEGMENT,
} from "@components/product-input/category-segments";
